#import "~/graphql/fragments/sections/default/baseEntryFields.graphql"
#import "~/graphql/fragments/assets/image.graphql"

fragment dossierPreview on dossier_Entry {
    ... baseEntryFields
    featuredImage {
        ... image
    }
    shortDescription
}
